import { css, LitElement } from 'lit';
import { listadoIconos } from './listado-iconos.js';


export default class SuperElement extends LitElement {
    static styles = [
        // Reset
        css`
            *,
            *::before,
            *::after {
                box-sizing: border-box;
                margin: 0;
                padding: 0;
                -webkit-text-fill-color: currentColor;
                font-weight: 400;
            }
        `,
        // Variables
        css`
            :host {
                --blanco: #FFFFFF;
                --negro: #4A4A4A;
                --gris: #C4C4C4;
                --gris-light: #F6F6F6;
                --gris-dark: #979797;
                --azul: #C6D8EB;
                --azul-light: #EEF5FE;
                --azul-dark: #1C62B2;
                --azul-mid: #56B1D8;
                --azul-dark-2: #014391;
                --amarillo: #FDC101;
                --amarillo-light: #FFEFBF;
                --amarillo-dark: #C79700;
                --rojo: #DC3912;
                --rojo-light: #F6CDC4;
                --rojo-dark: #961D00;
                --verde: #8FBF56;
                --verde-light: #D4E4C1;
                --verde-dark: #529405;
                
                --fw-thin: 100;
                --fw-light: 300;
                --fw-normal: 400;
                --fw-medium: 500;
                --fw-bold: 700;
                --fw-black: 900;
                
                --fs-xs: 10px;
                --fs-s: 12px;
                --fs-base: 14px;
                --fs-lg: 16px;
                --fs-xl: 18px;
                --fs-2xl: 24px;

                --box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                --input-height: 34px;
            }
        `,
        // Fuentes
        css`
            * {
                font-family: 'Roboto', sans-serif;
            }
        `,
        // Base iconos
        css`
            @font-face {
                font-family: 'inmovilla';
                src: url('fonts/inmovilla.woff2') format('woff2'),
                url('fonts/inmovilla.woff2') format('woff'),
                url('fonts/inmovilla.ttf') format('truetype'),
                url('fonts/inmovilla.svg') format('svg');
                font-weight: normal;
                font-style: normal;
            }
            
            .ic {
              display: inline-block;
              font-style: normal;
              font-variant: normal;
              font-weight: normal;
              line-height: 1;
              font-family: 'inmovilla' !important;
              speak: none;
              text-transform: none;
              /* Better Font Rendering */
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
            }
            
            .ic::before {
              font-family: inherit !important;
            }
        `,
        // Listado de iconos
        listadoIconos,
        // Elements
        css`
            *,
            *:focus,
            *:hover,
            input,
            select,
            input[list],
            textarea,
            option,
            button {
              outline: none;
            }
            
            *,
            *::before,
            *::after {
              -webkit-text-fill-color: currentColor !important;
            }
            
            body {
              -webkit-text-size-adjust: 100% !important;
            }
            
            li {
              list-style: none;
            }
            
            strong {
              font-weight: bold;
            }
            
            sup {
              line-height: 0;
              font-size: 0.83em;
              vertical-align: super;
            }
            
            button {
              cursor: pointer;
              border: none;
              background-color: transparent;
            }
            
            select,
            label[for],
            input[list],
            [type="color"] {
              cursor: pointer;
            }
            
            [type="text"],
            [type="number"],
            [type="email"],
            [type="password"],
            [type="search"],
            [type="date"],
            [type="time"],
            [type="datetime-local"],
            [type="color"],
            select,
            input[list],
            textarea {
              height: var(--input-height);
              border: 1px solid #CCC;
              padding: 6px 8px;
              background-color: var(--blanco);
              border-radius: 5px;
              transition: border-color 0.2s ease-out;
            }
            
            [type="text"]:disabled,
            [type="number"]:disabled,
            [type="email"]:disabled,
            [type="password"]:disabled,
            [type="search"]:disabled,
            [type="date"]:disabled,
            [type="time"]:disabled,
            [type="datetime-local"]:disabled,
            [type="color"]:disabled,
            select:disabled,
            input[list]:disabled,
            textarea:disabled {
              cursor: not-allowed !important;
              border-color: #CCC !important;
              background-color: var(--gris-light) !important;
            }
            
            [type="text"]:hover,
            [type="number"]:hover,
            [type="email"]:hover,
            [type="password"]:hover,
            [type="search"]:hover,
            [type="date"]:hover,
            [type="time"]:hover,
            [type="datetime-local"]:hover,
            [type="color"]:hover,
            select:hover,
            input[list]:hover,
            textarea:hover {
              border-color: var(--negro);  
            }
            
            [type="text"]:focus,
            [type="number"]:focus,
            [type="email"]:focus,
            [type="password"]:focus,
            [type="search"]:focus,
            [type="date"]:focus,
            [type="time"]:focus,
            [type="datetime-local"]:focus,
            [type="color"]:focus,
            select:focus,
            input[list]:focus,
            textarea:focus {
              border-color: var(--azul-dark);
            }
 
            [type="color"] {
              height: 30px;
              width: 30px;
              padding: 0 2px;
            }
            
            select[size] {
              height: auto;
            }
            
            textarea {
              height: 80px;
              resize: none;
            }
            
            select,
            input[list] {
              box-shadow: none;
              border: 1px solid #ccc;
              padding: 6px;
              background-color: var(--blanco);
              border-radius: 5px;
            }
            
            input[type="date"][placeholder]::before {
              color: #999999;
              content: attr(placeholder);
            }
            
            input[type="date"][placeholder] {
              color: var(--blanco);
            }
            
            input[type="date"][placeholder]:focus,
            input[type="date"][placeholder]:valid {
              color: #666666;
            }
            
            input[type="date"][placeholder]:focus::before,
            input[type="date"][placeholder]:valid::before {
              content: '' !important;
            }
            
            [type="search"] {
              padding: 8px 8px 8px 26px;
              background-color: var(--blanco);
              background-image: url('../../imagenes/componentes/buscador-lupa.svg');
              background-size: 16px;
              background-position: left 6px top 9px;
              background-repeat: no-repeat;
            }
            
            [type="checkbox"],
            [type="radio"] {
              width: 15px;
              height: 15px;
              background-color: var(--blanco);
              appearance: none;
              border: 1px solid #ccc;
              overflow: hidden;
              cursor: pointer;
            }
            
            [type="checkbox"]::after,
            [type="radio"]::after {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
            }
            
            [type="checkbox"]:disabled::after,
            [type="radio"]:disabled::after {
              cursor: default;
              background-color: var(--gris-light);
            }
            
            [type="checkbox"]:not(.input-switch) {
              border-radius: 4px;
            }
            
            [type="checkbox"]:not(.input-switch):not(.grupo-opciones__input) {
              position: relative;
            }
            
            [type="checkbox"]:not(.input-switch):not(.input-switch):checked::after {
              content: '✔';
              color: var(--blanco);
              text-align: center;
              font-size: 9px;
              background-color: #1C61B2;
            }
            
            [type="radio"] {
              position: relative;
              border-radius: 50%;
              border-color: var(--negro);
            }
            
            [type="radio"]::after {
              border: 2px solid #FFFFFF;
              border-radius: 50%;
            }
            
            [type="radio"]:checked {
              border-color: var(--azul-dark);
            }
          
            [type="radio"]:checked::after {
              background-color: #1C61B2;
            }
            
            [type="range"] {
              -webkit-appearance: none;
              width: 100%;
              height: 16px;
              overflow: hidden;
              border-radius: 17px;
              color: var(--azul);
              background-color: currentColor;
              border: 1px solid currentColor;
              cursor: pointer;
            }
            
            [type="range"]:focus {
              outline: none;
            }
            
            [type="range"]::-webkit-slider-runnable-track {
              -webkit-appearance: none;
              width: 100%;
              height: 14px;
              border-radius: 17px;
              background-color: currentColor;
            }
            
            [type="range"]::-webkit-slider-thumb {
              -webkit-appearance: none;
              width: 14px;
              height: 14px;
              border-radius: 50%;
              cursor: pointer;
              border: 1px solid var(--azul-dark-2);
              background: var(--azul-dark-2);
              box-shadow: -5000px 0 0 4992px var(--azul-dark);
            }
            
            ::-webkit-calendar-picker-indicator {
              cursor: pointer;
            }          
        `
    ];

    finCargaDOM() {
        return new Promise(resolve => setTimeout(resolve));
    }
}
